export function checkAll() {
  let checkbox = $('input[type="checkbox"');

  checkbox.on('change', function () {
    let name = $(this).attr('name');
    let input = $(`input[name="${name}"]`); 

    if($(this).hasClass('check-all')) {
      input.not(this).prop('checked', !this.checked);
    } else {
      $(`.check-all[name="${name}"]`).prop('checked', !input.is(':checked'));
    }
  });
}

export function clearQueryParams() {
  let link = location.protocol + '//' + location.host + location.pathname;

  $('.clear-query').on('click', function () {
    window.location.replace(link);
  });
}



// WEBPACK FOOTER //
// ./assets/js/modules/formControl.js